import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import Seo from "../../components/_UI/seo";
import AfiS1 from "../../components/afiS1";
import AfiS2 from "../../components/afiS2";
import AfiS3 from "../../components/afiS3";
import AfiS4 from "../../components/afiS4";
import AfiS5 from "../../components/afiS5";
import AboutS7 from "../../components/aboutS7";


const ApplyForIdoPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Заявка на IDO')}/>
            <div className={`${Styles.contentWrap}`}>
                <AfiS1/>
                <AfiS2/>
                <AfiS3/>
                <AfiS4/>
                <AfiS5/>
                <AboutS7/>
            </div>
        </section>
    );
};

export default ApplyForIdoPage;
